/**
 * Den build status — source of truth.
 *
 * The `den_catalog.status` column is unreliable (all 27 rows say 'built'
 * regardless of actual ship state). This list is the canonical record
 * of which Dens are actually shipped and ready to use today.
 *
 * Updated 2026-05-13. Order matters — these are the dens we sort to the
 * top of the chooser/adder grid in the rendered order.
 */
export const BUILT_DENS = [
  "founder",
  "recruiter",
  "investor",
  "podcast_host",
  "real_estate_investor",
  "course_creator",
  "creative_freelancer",
  "therapist",
  "executive",
  "journalist",
  "academic",
  "artist",
  "military",
] as const;

export type BuiltDenKey = (typeof BUILT_DENS)[number];

/** Fast lookup: O(1) "is this persona key actually shipped?". */
export const BUILT_DEN_SET: ReadonlySet<string> = new Set<string>(BUILT_DENS);

/** True iff the persona key is in BUILT_DENS. */
export function isDenBuilt(personaKey: string): boolean {
  return BUILT_DEN_SET.has(personaKey);
}

/** Sort comparator: built dens first (in BUILT_DENS order), then everything else by display_order. */
export function compareDensByBuildStatus<T extends { persona_key: string; display_order?: number | null }>(a: T, b: T): number {
  const aIdx = BUILT_DENS.indexOf(a.persona_key as BuiltDenKey);
  const bIdx = BUILT_DENS.indexOf(b.persona_key as BuiltDenKey);
  if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
  if (aIdx !== -1) return -1;
  if (bIdx !== -1) return 1;
  return (a.display_order ?? 999) - (b.display_order ?? 999);
}
